import * as React from "react"

export const Counter = () =>
  <script async src="https://stats.gomifu.com/script.js" data-website-id="f89325a9-1a25-4f32-8c10-157c8b95ccfb" />;

export default Counter;
